'use strict';
import recommendations from './product/recommendations';
import {dialogSDK} from './product/dialogSDK';
import optionalGDPR from '../optional-gdpr';

/**
 * Initializes the order confirmation page by checking for the presence of
 * the '.pt_order-confirmation' element. If present, it sets up event handlers
 * for input validation on the 'create-password' field, initializes optional
 * GDPR functionality, and clears specific items from local storage.
 */

// Handle the newsletter consent toggle for Italy
function handleNewsletterConsentToggleIT() {
    const $confirmationWrapper = $('.confirmation-login-box');
    const newsletterCB = $confirmationWrapper.find('.addtoemaillist');
    newsletterCB.on('change', function () {
        const isChecked = $(this).is(':checked');
        $confirmationWrapper.find('.user-consent-container .consentpref').prop('disabled', !isChecked);
    });
}

export default {
    init: function () {
        const $orderConfirmation = $('.pt_order-confirmation');
        if ($orderConfirmation.length) {
            handleNewsletterConsentToggleIT();
            recommendations.init();
            const $createPassword = $orderConfirmation.find('input.create-password');
            $createPassword.on('blur', function () {
                const $fieldErrorWrapper = $(this).parents('div.password-label'),
                    form = $orderConfirmation.find('.checkout-registration-form'),
                    validator = form.validate(),
                    validFlag = validator.element($(this));
                if (!validFlag) {
                    $fieldErrorWrapper.addClass('error');
                } else {
                    $fieldErrorWrapper.removeClass('error');
                }
            });

            if (SitePreferences.DIALOG_SCRIPT_ENABLED) {
                dialogSDK.initPDP();
            }

            if ( localStorage.getItem('storedproductid') && window.dialog && window.dialog.instance ) {
                const items = (orderConfirmation.productLineItems || []).map(product => ({
                    productId: product.id,
                    quantity: product.quantity,
                    price: product.price,
                    variantId: product.productVariantID
                }));

                window.dialog.instance.registerSubmitCheckoutEvent({
                    orderValue: orderConfirmation.gross,
                    currency: orderConfirmation.currencyCode,
                    transactionId: orderConfirmation.transactionId,
                    items
                });

                let storedProductIds = JSON.parse(localStorage.getItem('storedproductid')) || [];

                // Remove all purchased product IDs from localStorage
                const purchasedProductIds = items.map(item => item.productId);

                storedProductIds = storedProductIds.filter(
                    id => !purchasedProductIds.includes(id)
                );

                localStorage.setItem(
                    'storedproductid',
                    JSON.stringify(storedProductIds)
                );
            }

            optionalGDPR.init();
            const keysToRemove = [
                'storeDetailsSection',
                'selectedStoreData',
                'royalMail-edit',
                'storedAddressData'
            ];
            keysToRemove.forEach(key => localStorage.removeItem(key));
        } else {
            return;
        }
    }
}